import React, { FC, useEffect, useState } from "react";
import { Toggle } from "@climate-science/component-library";
import { Course } from "@cs/lib/models/skeleton.model";
import styles from "./CoursePage.module.scss";
import ChapterSelect
  from "../chapter/chapter-list/chapter-select/ChapterSelect";
import { useTranslation } from "next-i18next";
import Credits from "@cs/screens/chapter/chapter-list/credits/Credits";
import { populateStore } from "util/populatei18nStore";
import { useRouter } from "next/router";

export interface CoursePageProps extends Course {
  basic: boolean
}
const CoursePage: FC<CoursePageProps> = ({
  name,
  isSingleLOD,
  chapters,
  summary,
  basic,
  authors,
  artists,
  reviewers,
  translators,
  courseId,
  urlPart,
  externalReviewers
}) => {
  const [isBasic, setIsBasic] = useState(basic)
  const { t } = useTranslation("courses");
  const [render, setRender] = useState(false)
  const router = useRouter()

  const quizUrl = `/${basic ? 'simple' : 'advanced'}-${urlPart}-quiz`

  useEffect( () => {

    (async () => {
      setRender(false)
      await populateStore(router.locale as string, "courses", "en")
        .then(() => setRender(true))
    })()
        
  }, [router])

  if ( render ) {
    return (
      <section className={styles.coursePage}>
        <h3 className={styles.courseName}>
          {name}
          {
            courseId == "CS_1" && (
              <div className={styles.newSticker}>
                {t("new")}
              </div>
            )
          }
        </h3>
        <p className={styles.summary}>{summary}</p>
        {
          !isSingleLOD && (
            <div className={styles.difficultyToggle}>
              <Toggle 
                leftText={t("simple")}
                rightText={t("advanced")}
                onLeft={() => setIsBasic(true)}
                onRight={() => setIsBasic(false)}
                left={basic}
              />
            </div>
          )
        }
        <ChapterSelect 
          styles={styles}
          chapters={chapters}
          basic={isBasic}
          quizUrl={quizUrl}
          courseId={courseId}
        />
        <Credits
          artists={artists}
          authors={authors}
          reviewers={reviewers}
          translators={translators}
          externalReviewers={externalReviewers}
        />
      </section>
    )
  } else return <></>
}

export default CoursePage